<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title">404</h1>
            <h2 class="description">Page not found :(</h2>
            <h4 class="description">Ooooups! Looks like you got lost.</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "error-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg-error.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>
